var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "pwdForm",
          staticClass: "formContainer",
          attrs: {
            model: _vm.pwdForm,
            "status-icon": "",
            "label-position": "top",
            rules: _vm.pwdRules,
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("system.login_email") + ":",
                prop: "email",
              },
            },
            [
              _c("el-input", {
                attrs: { autocomplete: "off", disabled: "", clearable: "" },
                model: {
                  value: _vm.emailDesensitization,
                  callback: function ($$v) {
                    _vm.emailDesensitization = $$v
                  },
                  expression: "emailDesensitization",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { "margin-bottom": "40px" },
              attrs: {
                label: _vm.$t("system.password"),
                prop: "pass",
                required: "",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Enter your new password",
                  type: "password",
                  autocomplete: "off",
                  "show-password": "",
                  clearable: "",
                },
                model: {
                  value: _vm.pwdForm.pass,
                  callback: function ($$v) {
                    _vm.$set(_vm.pwdForm, "pass", $$v)
                  },
                  expression: "pwdForm.pass",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("system.confirm_password"),
                prop: "checkPass",
                required: "",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "Confirm your new password",
                  type: "password",
                  autocomplete: "off",
                  "show-password": "",
                  clearable: "",
                },
                model: {
                  value: _vm.pwdForm.checkPass,
                  callback: function ($$v) {
                    _vm.$set(_vm.pwdForm, "checkPass", $$v)
                  },
                  expression: "pwdForm.checkPass",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("system.mfa_verify_code"),
                prop: "mfa_code",
                required: "",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "6",
                  placeholder: "Enter your MFA verification code",
                  autocomplete: "off",
                  clearable: "",
                },
                model: {
                  value: _vm.pwdForm.mfa_code,
                  callback: function ($$v) {
                    _vm.$set(_vm.pwdForm, "mfa_code", $$v)
                  },
                  expression: "pwdForm.mfa_code",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }